import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { selectIsAuthenticated } from '../../store';
import { Store } from '@ngrx/store';

export const authGuard: CanActivateFn = () => inject(Store).select(selectIsAuthenticated);
